<div style="padding: 15px;">
  <div class="table-title">
     <h3>Reddit Submissions</h3>
  </div>
</div>

<form nz-form [formGroup]="filtersForm" class="filter-form">
  <div nz-row [nzGutter]="16">

    <div nz-col [nzSpan]="8">
      <nz-form-item>
        <nz-form-label>Subname</nz-form-label>
        <nz-form-control>
          <nz-select formControlName="subName"
                      nzShowSearch 
                      nzAllowClear 
                      nzPlaceHolder="Subname">
            <nz-option *ngFor="let subreddit of subredditList"
              [nzValue]="subreddit.name"
              [nzLabel]="subreddit.name"
            ></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col [nzSpan]="8">
      <nz-form-item>
        <nz-form-label>Politician</nz-form-label>
        <nz-form-control>
          <nz-select formControlName="politician" 
               nzShowSearch 
               nzAllowClear 
               nzPlaceHolder="Zgjidh politikanin e permendur">
            <nz-option
              *ngFor="let politician of politicians"
              [nzValue]="politician.id"
              [nzLabel]="politician.name"
            ></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>

  </div>

  <div nz-row [nzGutter]="16">
    <div nz-col [nzSpan]="8">
      <nz-form-item>
        <nz-form-label>Topic</nz-form-label>
        <nz-form-control>
          <nz-select formControlName="topic"
                      nzShowSearch 
                      nzAllowClear 
                      nzPlaceHolder="Tematika/ Fushata">
            <nz-option
              *ngFor="let topic of topics"
              [nzValue]="topic.id"
              [nzLabel]="topic.name"
            ></nz-option>
          </nz-select>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col [nzSpan]="8">
      <nz-form-item>
        <nz-form-label>Search text</nz-form-label>
        <nz-form-control>
          <input nz-input formControlName="searchBox" placeholder="Search by any keyword" />
        </nz-form-control>
      </nz-form-item>
    </div>

    <div nz-col [nzSpan]="8">
      <nz-form-item>
      &nbsp;&nbsp;
        <nz-form-control>
          <button nz-button nzType="primary" (click)="search()">
            <fa-icon [icon]="faSearch"></fa-icon> &nbsp;Filter
          </button>
        </nz-form-control>
      </nz-form-item>
    </div>
  </div>
</form>

<div class="table-container">
  <nz-table
    #basicTable
    nzSize="middle"
    [nzData]="submissions"
    [nzFrontPagination]="false"
    [nzLoading]="isDataLoading"
    [nzTotal]="totalCount"
    [nzPageSize]="pageSize"
    [nzPageIndex]="pageNumber"
    [nzPageSizeOptions]="pageSizeOptions"
    [nzShowSizeChanger]="true"
    [nzShowQuickJumper]="true"
    [nzShowPagination]="true"
    (nzQueryParams)="onQueryParamsChange($event)"
  >
    <thead>
      <tr>
        <th nzWidth="150px">Politician</th>
        <th>Sub</th>
        <th>Title</th>
        <th nzWidth="100px">Created at</th>
        <th>Topic</th>
        <th nzWidth="80px">Actions</th>
      </tr>
    </thead>
    <tbody>
      @for (submission of basicTable.data; track submission) {
      <tr>
        
        <!-- Politician column with inline edit -->
        <td>
          @if (!editCache[submission.id].edit) {
            {{ submission?.politicianName }}
          } @else {
            <nz-select 
                  [(ngModel)]="editCache[submission.id].data.politicianId"
                  nzShowSearch 
                  nzAllowClear 
                  style="width: 100%;">
              @for (politician of politicians; track politician) {
                @if (politician.id !== 0) { <!-- Skip "All" and "Unspecified" options -->
                <nz-option
                  [nzValue]="politician.id"
                  [nzLabel]="politician.name"
                ></nz-option>
                }  
              }
            </nz-select>
          }

        <td>r/{{ submission.subName }}</td>
        <td>{{ submission.title }}...</td>
        <td>{{ submission.createdAt| date: 'dd.MM.yyyy' }}</td>      
        
        <!-- Topic/Campaign column with inline edit -->
        <td>
          @if (!editCache[submission.id].edit) {
              {{ submission?.topicName }}
          } @else {
            <nz-select 
                   [(ngModel)]="editCache[submission.id].data.topicId" 
                   nzShowSearch 
                   nzAllowClear 
                   style="width: 100%;">
              @for (topic of topics; track topic) {
                @if (topic.id !== 0) { <!-- Skip "All" and "Unspecified" options -->
                  <nz-option
                    [nzValue]="topic.id"
                    [nzLabel]="topic.name"
                  ></nz-option>
                }
              }
            </nz-select>
          }
        </td>
        
        <!-- Action buttons -->
        <td class="action-buttons">
          @if (!editCache[submission.id].edit) {
            <button nz-button nzType="primary" nzShape="round" (click)="openSubmissionDetails(submission.id)">
              <fa-icon [icon]="faView"></fa-icon>
            </button>
            
            <button nz-button nzType="default" nzShape="round" (click)="startEdit(submission.id)">
              <fa-icon [icon]="faEdit"></fa-icon>
            </button>



            <button nz-button nzType="primary" nzDanger nzShape="round"
               nz-popconfirm nzPopconfirmTitle="Are you sure to remove this submission?"
               nzPopconfirmPlacement="left" [nzPopconfirmShowArrow]="false"
               (nzOnConfirm)="deactivateSubmission(submission.id)">
              <fa-icon [icon]="faRemove"></fa-icon>
            </button>
          } @else {
            <button nz-button nzType="primary" nzShape="round" (click)="saveEdit(submission.id, editCache[submission.id].data.politicianId??-1, editCache[submission.id].data.topicId??-1)" class="save-btn">
              <fa-icon [icon]="faSave"></fa-icon>
            </button>
            
            <button 
              nz-button 
              nzType="default" 
              nzShape="round" 
              nz-popconfirm 
              nzPopconfirmTitle="Sure to cancel?" 
              (nzOnConfirm)="cancelEdit(submission.id)"
            >
            <fa-icon [icon]="faCancel"></fa-icon>
            </button>
          }
        </td>
      </tr>
    }
    </tbody>
  </nz-table>
</div>